<nav class="secondary-nav" aria-label="FRM Lender Risk Management navigation">
  <fnma-menubar [menu]="menuItems()"></fnma-menubar>
</nav>
